import { createAction } from '@reduxjs/toolkit';

import { AuthActions, AuthInfoActions } from '../constants/auth';
import { ActionSuffixes } from '../constants/common/actions';

export const createSetMsalContextAction = () => createAction(AuthActions.MsalContext + ActionSuffixes._Set,
    (message) => ({ meta: { prefix: AuthActions.MsalContext }, payload: message }));

// profile
export const createGetProfileAction = () => createAction(AuthInfoActions.GetProfile);
export const createSetProfileAction = () => createAction(AuthInfoActions.Profile + ActionSuffixes._Set,
    message => ({ meta: { prefix: AuthInfoActions.Profile }, payload: message }));
    
export const createProfileLoadingAction = () => createAction(AuthInfoActions.IsProfileLoading + ActionSuffixes._Set,
    (value: boolean) => ({ meta: { prefix: AuthInfoActions.IsProfileLoading }, payload: value }));
    